import Heading3 from '../../../elements/titles/Heading3';
import Paragraph from '../../../elements/p/Paragraph';
import Container from '../../../utils/Container'
import revisionImg from '../../../../medias/svg/revision.svg'
import traductionImg from '../../../../medias/svg/traduction.svg'
import correctionImg from '../../../../medias/svg/correction.svg'


const Services = ({ classe }) => {
    return(
        <section className={`${classe} services-container relative md:absolute md:-top-28 lg:-top-24 w-full m-auto`}>
            <Container classe={`h-auto flex flex-col md:flex-row space-y-20 md:space-y-0 md:space-x-5 lg:space-x-14 items-center md:justify-between `}>
                <ServicesCard svg={revisionImg} classeImg="w-10 md:w-12" title="Révision" text="Je passe en revue vos documents pour corriger les fautes de grammaire, d'orthographe et les problèmes d'incohérences" />
                <ServicesCard svg={traductionImg} classeImg="w-10 md:w-12" title="Traduction" text="Traduction de tous types de supports(documents, sites web) en français, anglais et espagnol" />
                <ServicesCard svg={correctionImg} classeImg="w-8 md:w-10" title="Soutitrage" text="Augmentez le taux de consersion de vos vidéos avec en sous-titrage professionnel" />
            </Container>
        </section>
    )
}

const ServicesCard = ({ svg, title, text, classeImg }) => {
    return(
        <article className='serviceCard flex flex-col items-center bg-white rounded-md p-5 w-full md:w-96'>
                <img src={svg} alt="traduction" className={`${classeImg}`} />
                <Heading3 color="secondary" classe="text-center my-4">{title}</Heading3>
                <Paragraph classe="text-center">{text}</Paragraph>
        </article>
    )
}

export default Services